import { useState } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg from '@/components/base/SchemaOrg';
import PageMeta from '@/components/base/PageMeta';

export default function AboutPage() {
  const [contactFormOpen, setContactFormOpen] = useState(false);

  const milestones = [
    { year: '2015', event: '久久久久品牌创立，确立"持久稳定"核心理念' },
    { year: '2016', event: '建立首个品质检测实验室，推出九重品质管控体系' },
    { year: '2018', event: '服务客户突破500家，覆盖全国主要城市' },
    { year: '2020', event: '完成首轮技术升级，产品性能稳定性提升40%' },
    { year: '2022', event: '获得行业品质卓越奖，客户满意度达98.6%' },
    { year: '2024', event: '建立全球供应链体系，产品远销海外市场' },
    { year: '2026', event: '久久久久持续创新，为超过2000家客户提供持久稳定体验' },
  ];

  const values = [
    {
      icon: 'ri-heart-line',
      title: '客户至上',
      description: '久久久久始终将客户需求放在首位，以客户满意为最终衡量标准。我们坚信，只有真正为客户创造价值，品牌才能持久发展。',
    },
    {
      icon: 'ri-medal-line',
      title: '品质为先',
      description: '品质是久久久久的生命线。从原材料甄选到成品交付，每一个环节都经过严苛把控，确保每一件产品都达到超越期待的标准。',
    },
    {
      icon: 'ri-lightbulb-line',
      title: '持续创新',
      description: '久久久久持续投入研发创新，不断突破技术边界。我们相信，唯有不断创新，才能为客户提供更持久、更稳定的体验。',
    },
    {
      icon: 'ri-hand-heart-line',
      title: '诚信为本',
      description: '诚信是久久久久的基石。我们对客户的每一个承诺都全力以赴去兑现，以真诚和专业赢得每一位客户的长期信赖。',
    },
  ];

  const stats = [
    { value: '2,000+', label: '服务客户' },
    { value: '98.6%', label: '客户满意度' },
    { value: '10年+', label: '行业经验' },
    { value: '128项', label: '品质检测标准' },
  ];

  return (
    <PageMeta
      title="关于久久久久 - 专注持久稳定体验 | 品牌介绍"
      description="久久久久，专注持久稳定的极致体验。了解久久久久的品牌故事、核心价值观、发展历程以及专业团队，品质保障、长效服务、稳定性能、耐久方案，久久久久值得信赖。"
      keywords="久久久久,关于久久久久,久久久久品牌,久久久久持久体验,久久久久品质服务"
      canonicalUrl="https://jiujiujiujiu.com/about"
    >
      <SchemaOrg type="BreadcrumbList" data={{
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'https://jiujiujiujiu.com' },
          { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://jiujiujiujiu.com/about' },
        ],
      }} />

      <SchemaOrg type="WebPage" data={{
        name: '关于久久久久',
        url: 'https://jiujiujiujiu.com/about',
        description: '久久久久，专注持久稳定的极致体验。了解久久久久的品牌故事、核心价值观、发展历程以及专业团队。',
        isPartOf: { '@type': 'WebSite', name: '久久久久', url: 'https://jiujiujiujiu.com' },
      }} />

      <SchemaOrg type="Organization" data={{
        name: '久久久久',
        url: 'https://jiujiujiujiu.com',
        description: '久久久久，专注持久稳定的极致体验。品质保障、长效服务、稳定性能、耐久方案。',
        foundingDate: '2015',
        contactPoint: {
          '@type': 'ContactPoint',
          telephone: '+86-400-888-9999',
          contactType: 'customer service',
          availableLanguage: ['Chinese'],
        },
        address: {
          '@type': 'PostalAddress',
          addressLocality: '上海',
          addressRegion: '上海',
          addressCountry: 'CN',
          streetAddress: '浦东新区世纪大道100号',
        },
      }} />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <section className="pt-24 pb-10 md:pt-28 md:pb-14 bg-background-100">
            <div className="max-w-6xl mx-auto px-4 md:px-6">
              <Breadcrumb
                items={[
                  { label: '首页', href: '/' },
                  { label: '关于我们' },
                ]}
              />
              <div className="mt-6 text-center">
                <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-4">
                  关于久久久久
                </h1>
                <p className="text-sm md:text-base text-foreground-600 max-w-3xl mx-auto leading-relaxed">
                  久久久久，自2015年创立以来，始终专注于持久稳定的极致体验。
                  从品质保障到长效服务，从稳定性能到耐久方案，久久久久坚持以卓越的品质和可靠的服务，
                  成为广大客户信赖的长期合作伙伴。
                </p>
              </div>
            </div>
          </section>

          <section className="py-10 md:py-14 bg-background-50">
            <div className="max-w-4xl mx-auto px-4 md:px-6">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
                {stats.map((stat) => (
                  <div key={stat.label} className="text-center">
                    <p className="text-3xl md:text-4xl font-heading font-bold text-primary-500 mb-2">
                      {stat.value}
                    </p>
                    <p className="text-xs md:text-sm text-foreground-500">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="py-14 md:py-20 bg-background-100">
            <div className="max-w-6xl mx-auto px-4 md:px-6">
              <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
                <div className="w-full lg:w-1/2">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20minimal%20office%20interior%20with%20warm%20amber%20and%20terracotta%20accent%20walls%2C%20team%20collaboration%20in%20professional%20workspace%2C%20natural%20light%20from%20large%20windows%2C%20clean%20modern%20design%2C%20earthy%20warm%20tones%2C%20plants%20for%20natural%20touch%2C%20editorial%20photography%2C%20professional%20atmosphere&width=800&height=600&seq=about-brand-story&orientation=landscape"
                    alt="久久久久品牌故事"
                    className="w-full rounded-lg object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="w-full lg:w-1/2">
                  <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-6">
                    久久久久品牌故事
                  </h2>
                  <div className="space-y-4">
                    <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                      久久久久成立于2015年，由一群对品质有着极致追求的行业专家共同创立。
                      品牌名称"久久久久"蕴含着我们对持久稳定体验的执着追求——长长久久，经久不衰。
                    </p>
                    <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                      在快节奏的时代，久久久久选择了一条与众不同的道路——专注于打造能够经得起时间考验的产品和服务。
                      我们深知，真正的价值不在于一时的惊艳，而在于持久的陪伴和稳定的表现。
                    </p>
                    <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
                      十年来，久久久久从一个小型创业团队发展成为服务超过2000家客户的行业标杆。
                      我们的九重品质管控体系、全生命周期服务体系、多维冗余技术架构，每一项创新都源于对"持久稳定"这一核心理念的坚持。
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="py-14 md:py-20 bg-background-50">
            <div className="max-w-6xl mx-auto px-4 md:px-6">
              <div className="text-center mb-12 md:mb-16">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
                  久久久久核心价值观
                </h2>
                <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
                  四大核心价值观，指引久久久久不断前行
                </p>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
                {values.map((value) => (
                  <div
                    key={value.title}
                    className="bg-background-100 rounded-lg border border-background-200/70 p-6 md:p-8 text-center"
                  >
                    <div className="w-14 h-14 mx-auto flex items-center justify-center bg-accent-100 rounded-lg mb-5">
                      <i className={`${value.icon} text-2xl text-accent-600`}></i>
                    </div>
                    <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-3">
                      {value.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {value.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          <section className="py-14 md:py-20 bg-background-100">
            <div className="max-w-3xl mx-auto px-4 md:px-6">
              <div className="text-center mb-12 md:mb-16">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
                  久久久久发展历程
                </h2>
                <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
                  十年砥砺前行，久久久久与客户共同成长
                </p>
              </div>
              <div className="relative">
                <div className="absolute left-4 md:left-6 top-0 bottom-0 w-px bg-background-300"></div>
                <div className="flex flex-col gap-6 md:gap-8">
                  {milestones.map((milestone, index) => (
                    <div key={index} className="flex items-start gap-6 md:gap-8 pl-10 md:pl-14 relative">
                      <div className="absolute left-2.5 md:left-4.5 top-1 w-3 h-3 rounded-full bg-accent-500"></div>
                      <div>
                        <span className="text-xs font-semibold text-accent-500 bg-accent-100 px-2 py-0.5 rounded">
                          {milestone.year}
                        </span>
                        <p className="mt-2 text-sm md:text-base text-foreground-700 leading-relaxed">
                          {milestone.event}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>

          <section className="py-14 md:py-20 bg-background-50">
            <div className="max-w-6xl mx-auto px-4 md:px-6">
              <div className="text-center mb-12 md:mb-16">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
                  联系久久久久
                </h2>
                <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
                  久久久久期待与您的每一次交流，让我们共同打造持久稳定的美好体验
                </p>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14">
                <div className="space-y-8">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg flex-shrink-0">
                      <i className="ri-map-pin-line text-lg text-primary-600"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-heading font-semibold text-foreground-900 mb-1">公司地址</h4>
                      <p className="text-sm text-foreground-600 leading-relaxed">
                        中国上海市浦东新区世纪大道100号<br />
                        久久久久大厦18层
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg flex-shrink-0">
                      <i className="ri-phone-line text-lg text-primary-600"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-heading font-semibold text-foreground-900 mb-1">联系电话</h4>
                      <p className="text-sm text-foreground-600">400-888-9999</p>
                      <p className="text-xs text-foreground-400 mt-1">工作时间：周一至周五 9:00-18:00</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg flex-shrink-0">
                      <i className="ri-mail-line text-lg text-primary-600"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-heading font-semibold text-foreground-900 mb-1">电子邮箱</h4>
                      <p className="text-sm text-foreground-600">contact@jiujiujiujiu.com</p>
                      <p className="text-xs text-foreground-400 mt-1">我们会在24小时内回复您的邮件</p>
                    </div>
                  </div>
                </div>

                <div>
                  <button
                    onClick={() => setContactFormOpen(!contactFormOpen)}
                    className="w-full p-6 bg-background-100 border border-background-200/70 rounded-lg text-center cursor-pointer hover:border-primary-300 transition-all duration-300"
                  >
                    <div className="w-12 h-12 mx-auto flex items-center justify-center bg-primary-100 rounded-lg mb-4">
                      <i className="ri-chat-3-line text-xl text-primary-600"></i>
                    </div>
                    <h4 className="text-sm font-heading font-semibold text-foreground-900 mb-2">
                      在线留言
                    </h4>
                    <p className="text-xs text-foreground-500">
                      点击此处填写留言表单，久久久久将尽快回复
                    </p>
                  </button>

                  {contactFormOpen && (
                    <div className="mt-6 p-6 bg-background-100 border border-background-200/70 rounded-lg">
                      <ContactForm onClose={() => setContactFormOpen(false)} />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </PageMeta>
  );
}

function ContactForm({ onClose }: { onClose: () => void }) {
  const [submitted, setSubmitted] = useState(false);
  const [formError, setFormError] = useState('');

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('phone_alt') as HTMLInputElement)?.value.trim();
    if (honeypot) {
      setSubmitted(true);
      return;
    }
    const formData = new FormData(form);
    formData.delete('phone_alt');
    const params = new URLSearchParams();
    formData.forEach((value, key) => {
      params.append(key, value as string);
    });
    fetch('https://readdy.ai/api/form/d9rdt8fnahb7382ovl6g', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    })
      .then(async (res) => {
        const text = await res.text();
        let parsed: Record<string, unknown> = {};
        try { parsed = JSON.parse(text); } catch { /* ignore */ }
        if (res.ok && parsed?.code === 'OK') {
          setSubmitted(true);
          setFormError('');
          form.reset();
        } else {
          const metaMsg = (parsed?.meta as Record<string, string>)?.message;
          const msg = metaMsg || (parsed?.message as string) || text || '提交失败，请稍后重试';
          setFormError(msg);
        }
      })
      .catch(() => {
        setFormError('网络错误，请稍后重试');
      });
  };

  if (submitted) {
    return (
      <div className="text-center py-8">
        <div className="w-14 h-14 mx-auto flex items-center justify-center bg-secondary-100 rounded-full mb-4">
          <i className="ri-check-line text-2xl text-secondary-600"></i>
        </div>
        <p className="text-sm font-medium text-foreground-900 mb-2">感谢您的留言！</p>
        <p className="text-xs text-foreground-500">久久久久将在24小时内与您联系。</p>
        <button
          onClick={onClose}
          className="mt-4 text-xs text-primary-500 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          关闭
        </button>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-4" data-readdy-form="">
      {formError && (
        <p className="text-xs text-red-600 bg-red-50 p-3 rounded">{formError}</p>
      )}
      <div>
        <label htmlFor="about-name" className="block text-xs font-medium text-foreground-700 mb-1">
          姓名 <span className="text-accent-500">*</span>
        </label>
        <input
          id="about-name"
          name="name"
          type="text"
          required
          className="w-full px-3 py-2 text-sm border border-background-200 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-300 transition-colors"
          placeholder="请输入您的姓名"
        />
      </div>
      <div>
        <label htmlFor="about-email" className="block text-xs font-medium text-foreground-700 mb-1">
          邮箱 <span className="text-accent-500">*</span>
        </label>
        <input
          id="about-email"
          name="email"
          type="email"
          required
          className="w-full px-3 py-2 text-sm border border-background-200 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-300 transition-colors"
          placeholder="请输入您的邮箱"
        />
      </div>
      <div>
        <label htmlFor="about-message" className="block text-xs font-medium text-foreground-700 mb-1">
          留言内容 <span className="text-accent-500">*</span>
        </label>
        <textarea
          id="about-message"
          name="message"
          required
          maxLength={500}
          rows={4}
          className="w-full px-3 py-2 text-sm border border-background-200 rounded-md bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-300 transition-colors resize-none"
          placeholder="请输入您的留言内容（限500字）"
        ></textarea>
      </div>
      <input
        type="text"
        name="phone_alt"
        className="honeypot-field"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
      />
      <button
        type="submit"
        className="w-full py-2.5 bg-primary-500 text-background-50 text-sm font-medium rounded-md hover:bg-primary-600 transition-colors duration-200 cursor-pointer whitespace-nowrap"
      >
        提交留言
      </button>
    </form>
  );
}